import { BCMSRecord, useBCMSContext, useRoute, useWorkflowStep } from "@bcm-dev/bcms-vite";
import { getDefault, getWorkflowSteps } from "components/workflows/OneTimePaymentWorkFlow";
import { Card, LinkedAccount, Transaction } from "model";
import React from "react";


import { UIPrimaryButton } from "components/ui/UIButton";
import { SVGAsset } from "res";
import OneTimeDetailsWidget from "../OneTimeDetailsWidget";

/**
 * @function OneTimeScheduledView
 * @return {React.Component}
 * @exported true
 * @description •	This is the last step of the one time payment workflow.
 */
export default function OneTimeScheduledView(props) {
    const globalController = useBCMSContext();
    BCMSRecord.globalControllerFor([ Card ,LinkedAccount,Transaction ], globalController);   
    const workflowStep = useWorkflowStep(getDefault, getWorkflowSteps);
    const navigate = useRoute();
    return (
        <div className="one-time-scheduled-view">
            <div className="flex-container flex-vertical">
                <div className="flex-width circle-icon">
                    <div className="framed-icon-container">
                        <SVGAsset id="CheckingAccountIcon" />
                    </div>
                </div>
                <div className="flex-width header">
                    <p className="text-center"><b>Payment Scheduled</b></p>
                </div>
            </div>

            <OneTimeDetailsWidget details ={workflowStep.getStepState}/>

            <div className="flex-container flex-horizontal align-center-container info-container">
                <div className="set-width left-icon-container">
                    <SVGAsset id="InformationIcon" />
                </div>
                <div className="flex-width">
                    <span className="sub-text">Payments submitted after 5 PM Eastern Time on a business day will be credited the following business day.</span>
                </div>
            </div>
            <div className="flex-container flex-vertical all-center-container button-container">
                <UIPrimaryButton text="OK"  onClick={()=>navigate(-1)}/>
            </div>
        </div>
    )
}
